import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const ShareIcon: React.FC<IconBaseProps> = (props) => (
  <Icon viewBox="0 0 19 27" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.268 4.6559L5.645 5.0579C5.737 5.1539 5.884 5.1559 5.9735 5.0629L9 1.99887V17.0044H10.0005V1.86897L13.2535 5.1224C13.342 5.2139 13.4875 5.2119 13.579 5.1169L13.9925 4.7214C14.084 4.6269 14.086 4.4754 13.997 4.3834L10.2302 0.616626C10.2232 0.565308 10.2004 0.515439 10.162 0.475399L9.785 0.0733993C9.6925 -0.0226007 9.5455 -0.0246007 9.4565 0.0683993L5.2625 4.3144C5.173 4.4074 5.176 4.5604 5.268 4.6559ZM1 25.5044V8.5044H7V7.5044H0V26.5044H19V7.5044H12V8.5044H18V25.5044H1Z"
      fill="#007AFF"
    />
  </Icon>
);
export default ShareIcon;
